import { Err, Ok, Result } from "ts-results-es";
import { getAuthToken } from "./state";
import { IS_DEVELOPMENT } from "@src/constant";

export const BASE_URL =
  IS_DEVELOPMENT ? "http://bellys-macbook.local:8081" : "https://prep50.prep50exams.com";

export const ADMIN_URL =
  IS_DEVELOPMENT
    ? "http://bellys-macbook.local:8081/admin"
    : "https://prep50exams.com/admin";

export const ContentType = "Content-Type";
export const valync = async <T>(
  url: string,
  init?: RequestInit,
  use_full_path = false,
): Promise<Result<T, ApiError>> => {
  try {
    let headers = (init?.headers as Record<string, any>) ?? ({} as Record<string, any>);
    const contentType = headers[ContentType];

    const isFormData = init?.body instanceof FormData;

    const response = await fetch(encodeURI(use_full_path ? `${BASE_URL}${url}` : `${ADMIN_URL}${url}`), {
      ...init,
      headers: {
        ...init?.headers,
        ...(isFormData
          ? {}
          : {
              [ContentType]: contentType ?? "application/json",
            }),
        authorization: "Bearer " + getAuthToken(),
      },
    });
    if (response.status != 200) {
      const json = (await response.json()) as ErrorResponse;
      return Err(json.error);
    }

    const resp = (await response.json()) as ApiResponse<T>;
    if (resp.status == "failed") {
      return Err(resp.error);
    }

    return Ok(resp.data);
  } catch (e) {
    console.error(e);
    return Err({
      name: "Network Error",
      message: "Error connecting to server",
    });
  }
};
